import config from '../config'
import http from '../http'

export default{
	//仓库获取所有已处理的数据
		getProcessedOrderByStorelazada:async function(payload) {
				const res = await http({
					url: config.GET_STORE_PROCESSED_ORDER_LAZADA,
					method: 'post',
					data:{
						...payload
					}
				})
				return res.data
		},
	
	//仓库获取所有物流方式
		getLogisticsBystorelazada:async function(payload) {
				const res = await http({
					url: config.GET_LOGISTICS_STORE_LAZADA,
					method: 'post',
					data:{
						...payload
					}
				})
				return res.data
		},
	
		//仓库获取一段时间内打包的订单数量
		getProcessedOrdersByStorelazada:async function(payload) {
				const res = await http({
					url: config.GET_PROCESSED_ORDERS_PARAMS_STORE_LAZADA,
					method: 'post',
					data:{
						...payload
					}
				})
				return res.data
		},
	
	//获取已出库的订单信息-订单号查找
	getOrderByOrderId:async function(payload) {
			const res = await http({
				url: config.GET_ORDER_BY_ORDERID,
				method: 'get',
				data:{
					...payload
				}
			})
			return res.data
	},
	//仓库获取所有已处理的数据
	getProcessedOrderByStore:async function(payload) {
			const res = await http({
				url: config.GET_STORE_PROCESSED_ORDER,
				method: 'post',
				data:{
					...payload
				}
			})
			return res.data
	},
	//卖家获取所有已处理的数据
	getProcessedOrderBySeller:async function(payload) {
			const res = await http({
				url: config.GET_SELLER_PROCESSED_ORDER,
				method: 'post',
				data:{
					...payload
				}
			})
			return res.data
	},
	
	//仓库获取所有物流方式
	getLogisticsBystore:async function(payload) {
			const res = await http({
				url: config.GET_LOGISTICS_STORE,
				method: 'post',
				data:{
					...payload
				}
			})
			return res.data
	},
	//卖家获取所有物流方式
	getLogisticsByseller:async function(payload) {
			const res = await http({
				url: config.GET_LOGISTICS,
				method: 'post',
				data:{
					...payload
				}
			})
			return res.data
	},
	//仓库获取一段时间内打包的订单数量
	getProcessedOrdersByStore:async function(payload) {
			const res = await http({
				url: config.GET_PROCESSED_ORDERS_PARAMS_STORE,
				method: 'post',
				data:{
					...payload
				}
			})
			return res.data
	},
	//卖家获取一段时间内打包的订单数量
	getProcessedOrders:async function(payload) {
			const res = await http({
				url: config.GET_PROCESSED_ORDERS_PARAMS,
				method: 'post',
				data:{
					...payload
				}
			})
			return res.data
	},
	//获取仓库帐号下，所有已出库出库的订单
	getPackagedOrderByStore:async function(payload) {
		console.log(payload)
			const res = await http({
				url: config.GET_PACKED_ORDER_BY_STORE,
				method: 'post',
				data:{
					...payload
				}
			})
			return res.data
	},
	
	//获取印尼帐号已处理已出库出库的订单
	getIDacountProcessedList:async function(payload) {
		console.log(payload)
			const res = await http({
				url: config.GET_ID_ACCOUNT_PROCESS_LIST,
				method: 'post',
				data:{
					...payload
				}
			})
			return res.data
	},

	getProcessedOrderSn:async function(payload) {
		console.log(payload)
			const res = await http({
				url: config.GET_PROCESSED_ORDERSN,
				method: 'get',
				data:payload
			})
			return res.data
	},
	//获取已处理的订单信息
	getProcessedOrderInfo:async function(payload) {
		const res = await http({
			url: config.GET_PROCESSED_ORDERSN_INFO,
			method: 'post',
			data:payload
		})
		return res.data
	},
}